export const styles = {
  previewWrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    backgroundColor: 'black',
  },
  videoButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: '0.3s',
    borderRadius: '50%',
    backgroundColor: 'kit.background.purple',
    padding: {
      xs: '10px',
      xl: '10px 12px',
    },
    minWidth: 'unset',
    color: 'kit.text.mainInverse',
    justifyContent: 'flex-end',
    width: {
      xs: '48px',
      xl: '64px',
    },
    height: {
      xs: '48px',
      xl: '64px',
    },
    '.card &': {
      width: '48px',
      height: '48px',
    },
    '&:hover': {
      backgroundColor: {
        xs: 'kit.background.purple',
        xl: 'kit.background.turquoise',
      },
      color: {
        xs: 'kit.text.mainInverse',
        xl: 'kit.text.h',
      },
    },
    '&:active': {
      color: 'kit.text.accent',
    },
  },
  iconWrapper: {
    position: 'absolute',
    right: '20%',
    lineHeight: 0,
    width: {
      xs: '22px',
      xl: '30px',
    },
    '& svg': {
      width: '100%',
      height: 'auto',
    },
    '.card &': {
      width: '22px',
    },
  },
};
